const input = {
    username: 'Nome de usuário',
    password: 'Senha',
    email: 'E-mail',
    phone_number: 'Número de telefone',
    confirm_password: 'Confirme a senha',
    search_region_code: 'Pesquisar código de região',
    backup_code: 'Código de backup',
    code: 'Código',
    label_with_optional: '{{label}} (Opcional)',
};
export default Object.freeze(input);
